import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

toast.configure();
export const CourceClinicOptionFilters = memo((props) => {
  const { cource_clinic_id, options, using_option_ids } = props;
  // 初期設定
  const [usingOptionIds, setUsingOptionIds] = useState([]);
  useEffect(() => {
    setUsingOptionIds(using_option_ids);
  }, [])

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeOption = (event) => {
    const { value } = event.target;
    setUsingOptionIds(value);
  };

  const displayNames = (selected) => {
    var dispName = [];
    selected.map(selected_value => {
      options.map((option) => {
        if (option.id === selected_value) {
          dispName.push(option.name_ja);
        }
      })
    })
    return dispName.join(', ');
  }

  const onClickOptionsSubmit = () => {
    var data = { cource_clinic_option: { option_ids: usingOptionIds }};

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/cource_clinics/${cource_clinic_id}/cource_clinic_options`, data)
    .then(resp => {
      console.log(resp.data);
      setUsingOptionIds(resp.data);
      notify("success", "CourceClinicOption successfully created!");
    })
    .catch(e => {
      console.log("api ng");
      console.log(e.response);
      setUsingOptionIds(using_option_ids);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "CourceClinicOption create Error!");
    })
  }

  return (
    <>
      <FormControl sx={{ mr: 1, width: 250 }} size="small">
        <InputLabel id="multiple-checkbox-label">OP</InputLabel>
        <Select
          labelId="multiple-checkbox-label"
          id="multiple-checkbox"
          multiple
          value={usingOptionIds}
          onChange={onChangeOption}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => displayNames(selected)}
        >
          {options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <Checkbox checked={usingOptionIds.indexOf(option.id) > -1} />
              <ListItemText primary={option.name_ja} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <button onClick={onClickOptionsSubmit} className='btn btn-primary' title="Attributes">
        <i className='fas fa-filter' />
      </button>
    </>
  );
});
